import { LazyMotion, MotionConfig, domAnimation, m, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

export const motionPresets = {
  enter: { opacity: 1, y: 0 },
  initial: { opacity: 0, y: 8 },
  transition: { duration: 0.22, ease: "easeOut" as const },
} as const;

export function MotionBoundary({ children }: { readonly children: ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion features={domAnimation} strict>
        <m.div
          initial={reduce ? false : motionPresets.initial}
          animate={motionPresets.enter}
          transition={reduce ? { duration: 0 } : motionPresets.transition}
        >
          {children}
        </m.div>
      </LazyMotion>
    </MotionConfig>
  );
}
